import axios from "axios";

//IMPORT API ROUTE URL
import { REMOVE_RECOMMENDATION_HISTORY_ROUTE } from "./apiRoutes";

const removeRecommendation = (
  resource_slug,
  user_slug,
  recommendation_id,
  remark
) => {
  var postData = new FormData();

  postData.append("rm_slug", user_slug);
  postData.append("resource_slug", resource_slug);
  postData.append("recommendation_id", recommendation_id);
  postData.append("remove_remark", remark);

  return axios
    .post(REMOVE_RECOMMENDATION_HISTORY_ROUTE, postData)
    .then(function (response) {
      return response;
    })
    .catch(function (error) {
      return false;
    });
};

export default removeRecommendation;
